import React, { useState, useEffect } from 'react';
import { Badge, Card, Col, Pagination, Row, Table, Form, Spinner, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFilePdf, faTrash } from '@fortawesome/free-solid-svg-icons';

import { useTranslation } from "react-i18next";
const CheckCell = ({ claim , setChecks , checks}) => {
      const { t } = useTranslation();
    return (
        <td>
            {claim?._id && (
                <Form.Check
                    type="checkbox"
                    checked={checks[claim._id] || false}
                     disabled={claim.status !== "Waiting for Admin Action"}
                    onChange={(e) => {
                        const checked = e.target.checked; // copy first!
                        setChecks(prev => ({
                            ...prev,
                            [claim._id]: checked
                        }));
                    }}
                    label=""
                />
            )}
        </td>
    );
};

export default CheckCell;
